export const UNITS = {
  METER: 'm',
  SQUARE_METER: 'm²',
  CUBIC_METER: 'm³',
  KILOGRAM: 'kg',
  UNIT: 'kom',
  PAUSHAL: 'paušal',
  LITER: 'L',
  SET: 'set',
}; 